<template>
  <div class="" style="position: relative;">
    <v-toolbar>
      <v-toolbar-title>
        <v-btn @click="backPage()" class="back_button">
          <v-icon color="blue darken-2"> mdi-arrow-left </v-icon
          >マップ一覧に戻る
        </v-btn>
        検索グループの画像設定</v-toolbar-title>
    </v-toolbar>

    <!-- 

    {{map_data.group_label}} -->

    <v-card class="pa-4" max-width="100%" style="margin: 10px 10px;">
      <v-card-title>{{ slug }}</v-card-title>
      <div class="pa-4">

        <label>
            <input type="file" @change="loadCsvFile($event)" /><span
              style="color:red;font-size:12px;padding-left:10px;"
              >（CSVファイルから読み込む）</span
            >
          </label>

      </div>

    <table width="80%" class="group_table my-4">
      <tr><th style="background-color: transparent;">検索グループ名</th><th width=50 style="background-color: transparent;"></th><th style="background-color: transparent;">画像パス /wp-content/~</th></tr>
      <tr><th>name</th><th width=50></th><th>img</th></tr>

      <tr v-for="(item, index) in group_data" v-bind:key="index">
        <!-- <td class="text-center">
          <span style="color:red;font-size:70%"  v-if="item.flg == '0'">未使用</span>
        </td> -->
        <td>{{ item.name }}</td>
        <td class="text-center">
          <v-img width="40" :src="'https://appmedia.jp'+item.img" />

        </td>
        <td>
          <v-text-field
            outlined
            v-model="item.img"
            hide-details="true"
            dense
            single-line
            placeholder="画像パス /wp-content/~"
          ></v-text-field>
        </td>
      </tr>
    </table>




    <v-btn @click="save()" color="blue" style="color: #fff !important;" class="back_button ma-2">
      データ更新
    </v-btn>

    <!-- <v-btn @click="save()" color="red" class="back_button ma-2" outlined>
      本番反映（処理はまだ
    </v-btn> -->

    </v-card>


  </div>
</template>

<script>
import axios from "axios";
import Papa from "papaparse";

export default {
  name: "MapGenerateList",
  components: {},
  data() {
    return {
      master_data: [],
      map_data: [],
      parent_id: "",
      slug: "",
      id: "",
      map_name: "",
      csvData: [],

      //グループラベルデータ
      group_labels: {},
      group_data: [],

      message: "",
      update_message: "",
      items: [],

      //サブフラグ
      sub_flg: false,
      //更新フラグ
      update_flg: false,

      update_sub_ids: [], //更新するサブidを格納

      // icon_data = {},
    };
  },
  mounted() {
    var self = this;

    //マップデータの取得

    self.slug = this.$route.params.slug;

    
    self.id = this.$route.params.id;
    var access_url = "";

    access_url = process.env.VUE_APP_MAP_GROUP_SEARCH;
      axios
        .get(access_url, {
          params: {
            slug: self.slug,
          },
        })
        .then(function(response) {
          console.log("sub", response.data);

          self.group_data = response.data.group_search;

          // self.master_data = response.data.main;
          // self.map_data = JSON.parse(response.data.sub.content);

          // //メインデータに置き換え（基本情報)
          // var main = JSON.parse(response.data.main.content);
          // self.map_data.category = main.category;
          // self.map_data.icons = main.icons;

          // self.map_name =
          //   response.data.main.name + "_" + response.data.sub.name;

          // console.log("さぶ", self.map_data);


        })
        .finally(function() {});

    // if (typeof self.id !== "undefined" && self.id != -1) {
    //   access_url = process.env.VUE_APP_MAP_GROUP_SEARCH;
    //   axios
    //     .get(access_url, {
    //       params: {
    //         id: self.id,
    //         parent_id: self.parent_id,
    //       },
    //     })
    //     .then(function(response) {
    //       console.log("sub", response.data);
    //       self.master_data = response.data.main;
    //       self.map_data = JSON.parse(response.data.sub.content);

    //       //メインデータに置き換え（基本情報)
    //       var main = JSON.parse(response.data.main.content);
    //       self.map_data.category = main.category;
    //       self.map_data.icons = main.icons;

    //       self.map_name =
    //         response.data.main.name + "_" + response.data.sub.name;

    //       console.log("さぶ", self.map_data);


    //     })
    //     .finally(function() {});
    // } else {
    //   access_url = process.env.VUE_APP_MAP_DETAIL;
    //   axios
    //     .get(access_url, {
    //       params: {
    //         id: self.parent_id,
    //       },
    //     })
    //     .then(function(response) {
    //       self.master_data = response.data;

    //       self.map_data = JSON.parse(response.data.content);
    //       self.map_name = response.data.name;

    //       //サブマップがある場合はそちらを優先
    //       let sub_markes = response.data.sub_markes;
    //       if (sub_markes) {
    //         console.log("sub_markes", sub_markes);
    //         self.sub_flg = true;

    //         let all_data = {};

    //         for (const sub_map_id in sub_markes) {
    //           if (Object.hasOwnProperty.call(sub_markes, sub_map_id)) {
    //             const element = sub_markes[sub_map_id];
    //             // console.log("sub_markes", element.markers);

    //             for (let icon_id in element.markers) {
    //               if (!all_data[icon_id]) {
    //                 all_data[icon_id] = [];
    //               }

    //               const value = element.markers[icon_id];
    //               for (let index in value) {
    //                 const child = value[index];
    //                 child.sub_map_id = sub_map_id;
    //                 all_data[icon_id].push(child);
    //               }
    //             }
    //           }
    //         }
    //         console.log(all_data);
    //         self.map_data.markers = all_data;
    //       }

    //       self.group_data = self.splitData(self.map_data);

    //       console.log("group_data", self.group_data);
    //     })
    //     .finally(function() {});
    // }
  },

  computed: {},

  watch: {},

  methods: {
    backPage() {
      this.$router.push({
        name: "mapGenerate",
      });
    },
    iconName(no) {
      if (this.map_data.icons[no]) {
        return this.map_data.icons[no].name;
      }
      return no;
    },
    iconCategory(no) {
      if (this.map_data.icons[no]) {
        var category_id = this.map_data.icons[no].category;

        return this.map_data.category[category_id].id;
      }
      return no;
    },

    //CSVファイルのの読み込み
    loadCsvFile(e) {
      this.csvData = [];
      this.message = "";
      let file = e.target.files[0];
      this.update_flg = false;

      if (file.name && file.name.indexOf(".csv") <= -1) {
        this.message = "CSVファイルを選択してください";
        return;
      }

      let reader = new FileReader();
      reader.readAsText(file);
      reader.onload = () => {
        let csvData = reader.result;
        const parsed = Papa.parse(csvData, { header: true });
        this.rows = parsed.data;
        this.changeData(parsed.data);
      };
      console.log(this.map_data);
    },

    //読み込んだCSVデータの反映
    changeData(after) {
      this.update_message = "";
      this.update_flg = false;
      this.update_sub_ids = [];
      for (let key in after) {
        if ( after[key]["name"] != "") {
          this.$set(this.group_labels , after[key]["name"] , after[key]["img"])
        }
      }

      // //設定済み
      for(let img_no in this.group_data) {
        if(this.group_labels[this.group_data[img_no]["name"]]){
          this.group_data[img_no]["img"] = this.group_labels[this.group_data[img_no]["name"]];

          delete this.group_labels[this.group_data[img_no]["name"]]
        }
      }

      //未使用
      // for(let name in this.group_labels) {
      //   this.group_data.push({"name" : name, "img": this.group_labels[name] , "flg" : "0" })
      // }



    },

    //カンマ分割
    splitData(master) {

      //保存済みのグループデータ
      let tmp_group = master.group_data ? master.group_data : []
      let save_group = {};
      tmp_group.forEach(element => {
        save_group[element.name] = element.img
      });



      let output = [];
      let check = [];
      let data = master.markers;
      //マーカーに利用されているグループ
      for (let icon_no in data) {



        data[icon_no].forEach((element) => {
          let tmp = element["search_group"].split(",");

          tmp.forEach((item) => {
            if (check.indexOf(item) === -1 && item != "") {
              check.push(item);
              if(save_group[item]){
                output.push({ name: item, img: save_group[item] , flg: "1" });
              }else{
                output.push({ name: item , img: "", flg: "1"  });
              }
            }
          });
        });
      }


      //マーカーに利用されていないグループ(主にCSVインポートで作成されたデータ)
      for (let no in tmp_group) {
        if(check.indexOf(tmp_group[no]["name"]) === -1){
          output.push({ name: tmp_group[no]["name"],img: tmp_group[no]["img"] , flg: "0" });
        }
      }

      return output;
    },

    // fetchData(url, data) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .post(url, {
    //         data: data,
    //       })
    //       .then((response) => {
    //         resolve(response.data);
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });
    // },

    save() {
      // if (!this.update_flg) {
      //   console.log("何も変更されていない");
      //   return;
      // }
      let save_data = {};
      save_data.content = JSON.stringify(Object.assign({}, this.group_data));
      save_data.slug = this.slug;
      save_data.type = "group_search";

     axios
          .post(process.env.VUE_APP_MAP_INFO_UPDATE, {
            data: save_data,
          })
          .then(function(response) {
            console.log(response);
            //新規追加
            if (
              response.data["status"] == 0 ||
              response.data["status"] == 1 ||
              response.data["status"] == 2
            ) {
              if (response.data["status"] === false) {
                alert("データの保存に失敗しました。");
              } else {
                alert("データ更新しました！");
              }
            } else {
              if (response.data == "ERROR_SAME_NAME") {
                alert("同じ保存名が存在しています。");
              } else {
                alert("更新失敗しました！");
              }
            }
          })
          .finally(function() {
            // self.overlay = false;
          });


        console.log("何も変更されていない",save_data);
        return;

      // let saveData = Object.assign({}, this.master_data);
      // saveData.content = JSON.parse(saveData.content);
      // saveData.content.group_data = this.group_data;



   



      // return;

      // this.update_message = "";

      // console.log("this.update_sub_ids", this.update_sub_ids);
      // let updateItem = {};
      // // saveData.content = {};
      // // saveData.content.markers = {};

      // this.update_sub_ids.forEach((target_sub_id) => {
      //   console.log("map_data_markers", target_sub_id);
      //   updateItem[target_sub_id] = {};
      //   for (let img_no in this.map_data.markers) {
      //     const data = this.map_data.markers[img_no];
      //     data.forEach((element) => {
      //       if (element.sub_map_id == target_sub_id) {
      //         if (!updateItem[target_sub_id][img_no]) {
      //           updateItem[target_sub_id][img_no] = [];
      //         }
      //         updateItem[target_sub_id][img_no].push(element);
      //       }
      //     });
      //   }
      // });

      // //サブマップデータの更新
      // if (this.sub_flg) {
      //   var self = this;
      //   console.log(" ****** save_sub ******");
      //   this.update_sub_ids.forEach((sub_id) => {
      //     let saveData = Object.assign({}, this.master_data);
      //     const parent_id = saveData.id;
      //     saveData.parent_id = parent_id;
      //     saveData.id = sub_id;
      //     saveData.updata_content_only = true;
      //     saveData.content = {};
      //     saveData.content.markers = updateItem[sub_id];

      //     axios
      //       .post(process.env.VUE_APP_MAP_SUB_UPDATE, {
      //         data: saveData,
      //       })
      //       .then(function(response) {
      //         console.log(response);
      //         //新規追加
      //         if (
      //           response.data["status"] == 0 ||
      //           response.data["status"] == 1 ||
      //           response.data["status"] == 2
      //         ) {
      //           if (response.data["status"] === false) {
      //             alert("データの保存に失敗しました。");
      //           } else {
      //             self.update_message +=
      //               "サブマップID" + sub_id + "のデータを更新しました。<br />";

      //             // alert("データを保存しました。");
      //           }
      //         } else {
      //           if (response.data == "ERROR_SAME_NAME") {
      //             alert("同じ保存名が存在しています。");
      //           } else {
      //             alert("更新失敗しました！");
      //           }
      //         }
      //       })
      //       .finally(function() {
      //         // self.overlay = false;
      //       });
      //   });
      // } else {
      //   console.log(" ****** save_main ******");
      //   let saveData = Object.assign({}, this.master_data);
      //   saveData.content = JSON.parse(saveData.content);
      //   saveData.content.markers = this.map_data.markers;

      //   axios
      //     .post(process.env.VUE_APP_MAP_UPDATE, {
      //       data: saveData,
      //     })
      //     .then(function(response) {
      //       console.log(response);
      //       //新規追加
      //       if (
      //         response.data["status"] == 0 ||
      //         response.data["status"] == 1 ||
      //         response.data["status"] == 2
      //       ) {
      //         if (response.data["status"] === false) {
      //           alert("データの保存に失敗しました。");
      //         } else {
      //           this.update_message += "データを更新しました。<br />";
      //           // alert("データを保存しました。");
      //         }
      //       } else {
      //         if (response.data == "ERROR_SAME_NAME") {
      //           alert("同じ保存名が存在しています。");
      //         } else {
      //           alert("更新失敗しました！");
      //         }
      //       }
      //     })
      //     .finally(function() {
      //       // self.overlay = false;
      //     });
      // }
      // this.update_flg = false;

      // this.update_sub_ids.forEach((sub_id) => {
      //   let saveData = Object.assign({}, this.master_data);
      //   const parent_id =  saveData.id;
      //   saveData.parent_id = parent_id;
      //   saveData.id = sub_id;
      //   saveData.content = {};
      //   saveData.content.markers = updateItem[sub_id];
      //   // console.log("saveData", saveData.content);

      //   this.fetchData(process.env.VUE_APP_MAP_SUB_UPDATE,saveData).then(response => {
      //     // データの処理
      //                 console.log("sub_id",sub_id,response);
      //       //新規追加
      //       if (
      //         response.data["status"] == 0 ||
      //         response.data["status"] == 1 ||
      //         response.data["status"] == 2
      //       ) {
      //         if (response.data["status"] === false) {
      //           alert("データの保存に失敗しました。");
      //         } else {
      //           alert("データを保存しました。");
      //         }
      //       } else {
      //         if (response.data == "ERROR_SAME_NAME") {
      //           alert("同じ保存名が存在しています。");
      //         } else {
      //           alert("更新失敗しました！");
      //         }
      //       }
      //   })
      //   .catch(error => {
      //     // エラーの処理
      //     console.log(error);
      //   });

      //  axios
      //   .post(process.env.VUE_APP_MAP_SUB_UPDATE, {
      //     data: saveData,
      //   })
      //   .then(function(response) {
      //     console.log(response);
      //     //新規追加
      //     if (
      //       response.data["status"] == 0 ||
      //       response.data["status"] == 1 ||
      //       response.data["status"] == 2
      //     ) {
      //       if (response.data["status"] === false) {
      //         alert("データの保存に失敗しました。");
      //       } else {
      //         alert("データを保存しました。");
      //       }
      //     } else {
      //       if (response.data == "ERROR_SAME_NAME") {
      //         alert("同じ保存名が存在しています。");
      //       } else {
      //         alert("更新失敗しました！");
      //       }
      //     }
      //   })
      //   .finally(function() {
      //     // self.overlay = false;
      //   });
      // });
    },

    // backPage() {
    //   this.$router.push({
    //     name: "mapGenerate",
    //   });
    // },
  },
};
</script>
<style scoped>
.map_position_table {
  width: 100%;
  font-size: 12px;
}
.map_position_table th {
  background: #edd;
  padding: 4px;
}

.map_position_table td {
  text-align: center;
  border: 1px solid #ddd;
  background: #fff;
  padding: 4px;
}
.icon_list {
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.icon_list li {
  min-width: 80px;
  text-align: center;
  border: 1px solid #ddd;
  margin: 1px;
  font-size: 12px;
}
.flex_table {
  display: flex;
  flex-wrap: wrap;
}
.flex_table table {
  background: #fff;
}
.flex_table td, .group_table td{
  text-align: center;
  border: 1px solid #ddd;
  background: #fff;
}
.flex_table th  , .group_table th{
  background: rgb(135, 199, 239);
  padding: 4px;
}
.flex_table .map_setting_table {
  width: auto;
}

.group_table td ,.group_table th{
  font-size: 14px;
}


</style>
